import * as React from "react"

import { cn } from "@/lib/utils"

/** Общий вид поля ввода (input/select/textarea): 40px, радиус 12px, рамка border, фокус — accent. */
export const fieldClasses =
  "w-full rounded-xl border border-border bg-surface px-3 text-sm text-text transition-[border-color,box-shadow] outline-none placeholder:text-text-3 focus-visible:border-accent-text focus-visible:ring-3 focus-visible:ring-accent/35 disabled:cursor-not-allowed disabled:bg-surface-alt disabled:opacity-60 aria-invalid:border-[1.5px] aria-invalid:border-neg aria-invalid:focus-visible:ring-neg/20"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          fieldClasses,
          "flex h-10 py-1 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-text [&[type=date]]:tabular-nums [&[type=datetime-local]]:tabular-nums",
          className
        )}
        ref={ref}
        {...props} />
    );
  }
)
Input.displayName = "Input"

export { Input }
